<template>
<div style="height:100%">
  <div id="csContainer">
    <div class="toolbar">
      <input type="button" value="绘制图形"  class="btn btn-primary" @click="drawPolygon()">
      <input type="button" value="清除"  class="btn btn-primary" @click="dele()">
      <br/>
      <br/>
      <span>基准面高度：</span>
      <input type="number" v-model="excavateHeight" min="1" step="1" class="form-control" style="width:100px">（米）
      <input type="button" value="方量分析"  class="btn btn-primary" @click="elAnalyse()">
    </div>
  </div>
   <div id="loadingOverlay"><h1>Loading........</h1></div>
</div>
</template>
<script>
/*eslint-disable*/
import * as Cesium from "cesium/Cesium";
import widgets from "cesium/Widgets/widgets.css";
const turf = require('@turf/turf');

import util from "../../components/util"
export default {
    name: 'headMap',
    data(){
        return{
            isShow: false,
            viewer: null,
            length: 1.5,
            buryHeight: 6000,
            excavateHeight: 3500,
            drawingMode :'polygon',
            activeShapePoints : [],
            activeShape:null,
            floatingPoint:null,
            points:[]
        }
    },
    mounted(){
      var loa=document.getElementById('loadingOverlay');
        setTimeout(()=>{
           loa.style.display="none";
       },4000);
        this.init();
    },
    methods:{
        init(){
            if(this.$device !== 'pc'){
              this.$message({
                showClose: true,
                message: '手机端由于绘制机制暂未开放，请用电脑端使用该功能。',
                duration: 10000
              });
            }
            let terrainProvider = Cesium.createWorldTerrain({
              requestWaterMask: true,
              requestVertexNormals: true
            });

            let viewer = util.getViewer("csContainer",{
              // imageryProvider: new Cesium.UrlTemplateImageryProvider({
              //   url: 'http://www.google.cn/maps/vt?lyrs=s@716&x={x}&y={y}&z={z}'
              // }),
              terrainProvider: terrainProvider,
              homeButton: false,
              sceneModePicker: false,
              baseLayerPicker: false,
            });

            this.viewer = viewer;
            viewer.scene.globe.depthTestAgainstTerrain = true;
            viewer.disableDepthTestDistance = Number.POSITIVE_INFINITY;
            let heading = 5.393693269104002;
            let pitch = -0.3798025510201679;
            let roll = 6.280767850782176;
            viewer.camera.setView({
              destination : Cesium.Cartesian3.fromDegrees(99, 29,50000),
              orientation: {
                heading,
                pitch,
                roll
              }
            });
            // let excavateHeight = 2300; // 开挖高度
            // let buryHeight = 6000; // 填埋高度
        },
      elAnalyse(){
        this.$message({
                    showClose: true,
                    message: '红色面为基准面高度，蓝色为分析区域',
                    duration: 10000
                });
        let self = this;
        let viewer = this.viewer;
        if(this.points.length !== 0 ){
          this.points.splice(0,1);
          let longitude = [];
          let latitude = [];
          for (let i = 0;i<this.points.length;i++){
            longitude.push(this.points[i][0]);
            latitude.push(this.points[i][1]);
          }
          let extent = [Math.min.apply(null,longitude), Math.min.apply(null,latitude), Math.max.apply(null,longitude), Math.max.apply(null,latitude)];
          let pointsCesium = this.points;
          this.points.push(this.points[0]);
          let polygonArray = this.points;
          let polygon = turf.polygon([polygonArray]);
          let center = turf.centerOfMass(polygon);
          let area = turf.area(polygon)/1000000/1000;
          let cellSide = Math.sqrt( area)
          let options = {
            units: 'kilometers',
            mask : polygon
          };
          let grid = turf.pointGrid(extent, cellSide, options);
          let centerPoints= []; // 分割单元中心点
          for (let i=0;i<grid.features.length;i++){
            let centerPoint = Cesium.Cartographic.fromDegrees(grid.features[i].geometry.coordinates[0],
                    grid.features[i].geometry.coordinates[1]);
            centerPoints.push(centerPoint);
          }

          let promise = Cesium.sampleTerrain(viewer.terrainProvider,7,centerPoints);
          Cesium.when(promise,function(updatedPositions){
             let heights = [];
            updatedPositions.forEach(point => {
              heights.push(point.height);
            });
            // 开始计算土方
            var excavateVolumes = 0;
            var buryVolumes = 0;
            for (var i = 0; i < heights.length; i++) {
              // 挖方
              if (heights[i] > self.excavateHeight) { // 如果地形高度大于开挖高度才需要开挖
                var excavateVolume = self.length*1000*self.length*1000 * (heights[i] - self.excavateHeight);
                excavateVolumes += excavateVolume;
              }
              // 填埋
              if (heights[i] < self.excavateHeight) { // 如果地形高度小于填埋高度才需要填埋
                var buryVolume = self.length*1000*self.length*1000 * (self.excavateHeight - heights[i]);
                buryVolumes += buryVolume;
              }
            }
            viewer.entities.removeAll();
            let scope = [];
            for (let m=0; m<pointsCesium.length;m++){
              scope.push(Cesium.Cartesian3.fromDegrees(pointsCesium[m][0], pointsCesium[m][1]))
            }
            scope.pop();
            let entity1 = viewer.entities.add({
              polygon:{
                hierarchy: scope,
                height: self.excavateHeight,
                // extrudedHeight: this.buryHeight-this.excavateHeight,
                material: Cesium.Color.RED.withAlpha(0.5),
                outline: true,
                // closeTop: false
              }
            });

            let entity2 = viewer.entities.add({
              polygon:{
                hierarchy: scope,
                height: -1000,
                extrudedHeight: 6589,
                material: Cesium.Color.BLUE.withAlpha(0.5),
                outline: true,
                closeTop: false
              }
            });
            let entity22 = viewer.entities.add({
              position: Cesium.Cartesian3.fromDegrees(center.geometry.coordinates[0], center.geometry.coordinates[1],
                      heights[0] + 5000 ),
              label:{
                text: '挖方体积:'+ excavateVolumes + "立方米"+ "\n"+"填埋体积:"+ buryVolumes + "立方米",
                font: '20px sans-serif',
                fillColor: Cesium.Color.GOLD,
                style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                outlineWidth: 2,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
              },
            });
          })
        }
      },
      createPoint(worldPosition) {
        let position = this.viewer.scene.globe.ellipsoid.cartesianToCartographic(worldPosition);
        let longitude = Cesium.Math.toDegrees(position.longitude);
        let latitude = Cesium.Math.toDegrees(position.latitude);
        let position2 = [longitude,latitude];
        this.points.push(position2);
        var point = this.viewer.entities.add({
          position : worldPosition,
          point : {
            color : Cesium.Color.RED,
            pixelSize : 5,
            heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
          }
        });
        return point;
      },
      drawShape(positionData) {
        var shape;
        if (this.drawingMode === 'line') {
          shape = this.viewer.entities.add({
            polyline : {
              positions : positionData,
              clampToGround : true,
              width : 3,
              material:new Cesium.Color.fromBytes(64, 157, 253, 150)
            }
          });
        }
        else if (this.drawingMode === 'polygon') {
          shape = this.viewer.entities.add({
            polygon: {
              hierarchy: positionData,
              material: new Cesium.Color.fromBytes(64, 157, 253, 150),
              fill:true,
              outline:true,
              outlineColor: Cesium.Color.RED,
              outlineWidth:10
            }
          });
        }
        return shape;
      },
      terminateShape() {
        this.activeShapePoints.pop();
        // this.drawShape(this.activeShapePoints);
        this.viewer.entities.remove(this.floatingPoint);
        this.viewer.entities.remove(this.activeShape);
        this.floatingPoint = null;
        this.activeShape = null;
        this.activeShapePoints = [];
        // this.viewer.entities.removeAll();
      },
      drawPolygon(positiondata){
        this.$message({
                    showClose: true,
                    message: '鼠标左击绘制分析区域，鼠标右击结束绘制',
                    duration: 10000
                });
        this.viewer.entities.removeAll();
        this.points = [];
        this.terminateShape();
        this.drawingMode='polygon';
        this.viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
        var handler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);
        var that=this;
        handler.setInputAction((event)=> {
          let ray = that.viewer.camera.getPickRay(event.position);
          let   earthPosition = that.viewer.scene.globe.pick(ray, that.viewer.scene);
          if (Cesium.defined(earthPosition)) {
            if (that.activeShapePoints.length === 0) {
              that.floatingPoint = that.createPoint(earthPosition);
              that.activeShapePoints.push(earthPosition);
              var dynamicPositions = new Cesium.CallbackProperty(function () {
                return new Cesium.PolygonHierarchy(that.activeShapePoints);
              }, false);
              that.activeShape = that.drawShape(dynamicPositions);
            }
            that.activeShapePoints.push(earthPosition);
            that.createPoint(earthPosition);
          }
        }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
        handler.setInputAction((event)=> {
          if (Cesium.defined(that.floatingPoint)) {
            // var newPosition = that.viewer.scene.pickPosition(event.endPosition);
            let ray = that.viewer.camera.getPickRay(event.endPosition);
            let   newPosition = that.viewer.scene.globe.pick(ray, that.viewer.scene);
            if (Cesium.defined(newPosition)) {
              that.floatingPoint.position.setValue(newPosition);
              that.activeShapePoints.pop();
              that.activeShapePoints.push(newPosition);
            }
          }
        }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
        handler.setInputAction((event)=> {
          // this.terminateShape();
          handler.destroy();

        }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);

      },
      dele(){
        this.viewer.entities.removeAll();
      }


    },

}
</script>
<style scoped>

  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
    position: relative;
  }
  .toolbar{
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    width: 360px;
    height: 100px;
    top: 10px;
    left: 10px;
    padding: 10px 15px;
    border-radius: 4px;
    border: 1px solid rgba(128,128,128,.5);
    color: #fff;
    background: rgba(0,0,0,.4);
    box-shadow: 0 3px 14px rgba(128,128,128,.5);
    z-index: 100;
  }
  .form-control{
    color: #fff;
    background-color: rgba(63,72,84,.7);
    border: none;
  }
  .btn-primary{
    color:#fff;
    background-color: rgba(32,160,255,.2);
    cursor: pointer;
    margin: 0 2px 0 2px;
    border: 1px solid #e4eaec;
    border-radius: 3px;
  }
</style>
